import * as React from 'react'
import { isRtl } from '../../../i18nInit'
import { t } from 'ttag'
import YumButton from '../../YumButton/YumButton'
import { ExportGoalResults$Request, GoalId } from '../../../services/api.types'
import { Box } from '@material-ui/core'
import { ReactComponent as IconDownload } from '../../../assets/v3/icons/ranking/download.svg'

export interface IYumGoalRankingExportButtonProps {
  goalId: GoalId
  exportInProgress: boolean
  style?: React.CSSProperties
}

export interface IYumGoalRankingExportButtonDispatchProps {
  getCurrentGoalExport(payload: ExportGoalResults$Request): void
}

export const YumGoalRankingExportButton = (
  props: IYumGoalRankingExportButtonProps & IYumGoalRankingExportButtonDispatchProps,
) => {
  const { goalId, getCurrentGoalExport, exportInProgress, style } = props

  const onExport = () => {
    getCurrentGoalExport({ goalId })
  }

  return (
    <YumButton
      variant="outlined"
      size="small"
      aria-label={t`Export`}
      style={
        !isRtl
          ? {
              marginRight: '8px',
            }
          : {
              marginLeft: '8px',
            }
      }
      onClick={onExport}
      disabled={exportInProgress}
      showLoader={exportInProgress}
      immersiveLoader={true}
      darkLoader={true}
    >
      <IconDownload style={{ width: '1rem', height: '1rem' }} />
      <Box
        display={{ xs: 'none', md: 'inline' }}
        style={{ marginLeft: isRtl ? 0 : '8px', marginRight: isRtl ? '8px' : 0 }}
      >{t`Export`}</Box>
    </YumButton>
  )
}
